import { Discount } from '../hooks/webapi/useDiscounts';
import { getToday } from 'utils/shiftedDateTime';

interface IsDiscountActiveProps {
  amount?: number;
  availableDiscounts?: Discount[];
}

export function isDiscountActive({
  amount,
  availableDiscounts,
}: IsDiscountActiveProps) {
  if (!amount || !availableDiscounts) return false;
  const validAmount = availableDiscounts.some((discount) =>
    discount.amountRanges.some(
      ({ max, min }) => amount <= max && amount >= min,
    ),
  );
  const currentDate = getToday();
  const validDate = availableDiscounts.some((discount) =>
    discount.validityRanges.some(({ max, min }) => {
      if (!max || !min) return false;
      const today = new Date(currentDate).setHours(0, 0, 0, 0);
      const maxDate = new Date(max).setHours(0, 0, 0, 0);
      const minDate = new Date(min).setHours(0, 0, 0, 0);
      return today <= maxDate && today >= minDate;
    }),
  );
  return validAmount && validDate;
}
